import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class Emarsys implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_EMARSYS;
  label: string = 'Emarsys';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = false;

  getClientIdRegexp(): RegExp {
    return /^[A-Z0-9]+$/;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
